<template>
  <page-container title="Settings">
    <template v-slot:subheaderView>
      <v-tabs v-model="selectedTab">
        <v-tab :to="{ name: 'company-settings' }">Company</v-tab>
      </v-tabs>
    </template>
    <router-view></router-view>
  </page-container>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
export default {
  name: 'Settings',
  components: {
    PageContainer
  },
  data() {
    return {
      selectedTab: 0
    }
  }
}
</script>
